module.exports = require("@bechtel/client-dashboard-common");